<template>
  <div class="row spinner-parent">
    <spinner ref="spinner" size="md" text="Loading ..." />

    <div v-if="source" class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Edit redirect with id {{ source.id }}</h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Source *</label>
                  <div class="col-md-10">
                    <input
                      id="source"
                      v-model="entity.source"
                      type="text"
                      placeholder="Enter source"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="title" class="col-md-2">Destination *</label>
                  <div class="col-md-10">
                    <input
                      id="destination"
                      v-model="entity.destination"
                      type="text"
                      placeholder="Enter destination"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Redirect has modified successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div><!--/.row-->
</template>

<script>
import _ from 'lodash';
// Mixins
import EditPageMixin from '@/mixins/EditPageMixin';

export default {
  name: 'RedirectEdit',

  mixins: [EditPageMixin],

  data() {
    return {
      source: null,
      entity: {},
    };
  },

  methods: {
    isEntityValid() {
      if (!this.entity.source) {
        this.$_errorSave('Source field is required');
        return false;
      }
      if (!this.entity.destination) {
        this.$_errorSave('Destination field is required');
        return false;
      }
      return true;
    },
    getSource() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}redirects/${this.$route.params.id}`)
        .then((response) => {
          this.source = response.data;
          this.entity = _.cloneDeep(response.data);
          if (!Object.prototype.hasOwnProperty.call(response.data, 'cover')) {
            this.source.cover = null;
            this.entity.cover = null;
          }
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          setTimeout(this.manuallyAddFiles, 100);
        })
        .catch((error) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting data request' });
          console.log('Error in get image gallery query', error);
        });
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('source', this.entity.source);
      postFormData.append('destination', this.entity.destination);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}redirects/${this.$route.params.id}`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then(() => {
        this.$_successSave();
        this.$parent.getSource();
      }).catch((error) => {
        this.$_showError(error);
        console.error('Error in update redirect query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// Edit.vue?5a96324c